import { ISearchState } from "./interfaces";

export const DEFAULT_SEARCH_STATE: ISearchState = {
	query: "",
	queryId: "",
};
